import { render, staticRenderFns } from "./teachersForm.vue?vue&type=template&id=f9d90e3c&"
import script from "./teachersForm.vue?vue&type=script&lang=js&"
export * from "./teachersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports